import React, { useEffect } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import { genderData, propertyTypeListUP, schemeNameList } from "../../../../TCPForms/data";
import { Box, IconButton } from "@mui/material";
import { useSelector } from "react-redux";

const SubStep4 = ({ formData, handleSubTabChange }) => {
    const { documents } = useSelector(state => state.formMT);
    const { t } = useTranslation();
    const propertyEntry = {
        sectorNo: null,
        propertyNo: null,
        schemeName: null,
        block: null,
        khataNo: null,
        khasraNo: null,
        khatauniNo: null,
        plotArea: 0,
        plotNo: null,
        roadWidth: null,
        appliedLandUse: {
            name: null,
        },
        propertyType: {
            name: null,
        },
        propertyAddress: {
            address: null,
            state: null,
            pinno: null,
            district: null
        }
    };
    const defaultValues = {
        ...formData,
        documents,
        landInfo: {
            ...formData?.landInfo,
        },
        descriptionOfLand: {
            ...formData?.descriptionOfLand,
            properties: formData?.descriptionOfLand?.properties?.length > 0 ? formData?.descriptionOfLand?.properties : [propertyEntry]
        }
    };
    const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({ defaultValues });

    const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
    const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes("up"))

    const { fields: properties, append: appendProp, remove: removeProp } = useFieldArray({
        control,
        name: "descriptionOfLand.properties",
    });
    const morethanOneProperty = formData?.morethanOneProperty === 'yes'
    const watchApprovedLayout = formData?.approvedLayout === 'yes'

    useEffect(() => {
        setValue('documents', documents);
    }, [documents]);

    const onSubmit = (data) => {
        handleSubTabChange(4, data)
    };
    return (
        <section className="groupContainer">
            <form onSubmit={handleSubmit(onSubmit)}>
                {!watchApprovedLayout && <div className="formContainer">
                    {properties?.map((property, index) => (
                        <React.Fragment>
                            <div className="formHeaderContainer">
                                <h2 className="formHeading">
                                    {index > 0 ? t("Additional Registration Information") : t("Registration Information")}                                    </h2>
                            </div>
                            <div className="formInputContainer">
                                <div className="columnWrapper">
                                    <InputWrapper
                                        label={t("LABEL_KHASRA_NO")}
                                        control={control}
                                        placeholder={t("LABEL_ENTER_KHASRA_NO")}
                                        defaultValue={property.khasraNo}
                                        name={`descriptionOfLand.properties[${index}].khasraNo`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        label={t("LABEL_KHATA_NO")}
                                        control={control}
                                        placeholder={t("LABEL_ENTER_KHATA_NO")}
                                        defaultValue={property.khataNo}
                                        name={`descriptionOfLand.properties[${index}].khataNo`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        label="Plot Area"
                                        control={control}
                                        placeholder="Enter Plot Area"
                                        defaultValue={property.plotArea}
                                        name={`descriptionOfLand.properties[${index}].plotArea`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        label="Land use as per master plan"
                                        control={control}
                                        placeholder="Enter Land use as per master plan"
                                        defaultValue={property.appliedLandUse.name}
                                        name={`descriptionOfLand.properties[${index}].appliedLandUse.name`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        label="Scheme Name"
                                        control={control}
                                        placeholder="Select Scheme Name"
                                        defaultValue={property.schemeName}
                                        name={`descriptionOfLand.properties[${index}].schemeName`}
                                        type="selectInput"
                                        mandatory
                                        data={schemeNameList}
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        control={control}
                                        label={t("LABEL_ADDRESS")}
                                        placeholder={t("LABEL_ENTER_ADDRESS")}
                                        defaultValue={property.propertyAddress.address}
                                        name={`descriptionOfLand.properties[${index}].propertyAddress.address`}
                                        type="textInput"
                                        mandatory
                                        multiLine
                                        maxLength={150}
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                            pattern: {
                                                value: Digit.Utils.getPattern('Address'),
                                                message: "Please enter valid Address",
                                            },
                                        }}
                                    />
                                </div>
                                <div className="columnWrapper">
                                    <InputWrapper
                                        label="Khatuni No."
                                        control={control}
                                        placeholder="Enter Khatuni No."
                                        defaultValue={property.khatauniNo}
                                        name={`descriptionOfLand.properties[${index}].khatauniNo`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        label={t("LABEL_PLOT_NO")}
                                        control={control}
                                        placeholder={t("LABEL_ENTER_PLOT_NO")}
                                        defaultValue={property.plotNo}
                                        name={`descriptionOfLand.properties[${index}].plotNo`}
                                        type="textInput"
                                        maxLength={10}
                                    />
                                    <InputWrapper
                                        label="Road Width"
                                        control={control}
                                        placeholder="Enter Road Width"
                                        defaultValue={property.roadWidth}
                                        name={`descriptionOfLand.properties[${index}].roadWidth`}
                                        type="textInput"
                                        mandatory
                                        //maxLength={10}
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        control={control}
                                        data={updistricts}
                                        label={t("LABEL_CITY")}
                                        placeholder={t("LABEL_ENTER_CITY")}
                                        defaultValue={property.city}
                                        name={`descriptionOfLand.properties[${index}].city`}
                                        type="selectInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            }
                                        }}
                                    />
                                    <InputWrapper
                                        control={control}
                                        label={t("LABEL_STATE")}
                                        defaultValue={property.propertyAddress.state || t("LABEL_STATE_UP")}
                                        name={`descriptionOfLand.properties[${index}].propertyAddress.state`}
                                        type="textInput"
                                        disabled
                                    />
                                    <InputWrapper
                                        control={control}
                                        label={t("LABEL_PINCODE")}
                                        placeholder={t("LABEL_ENTER_PINCODE")}
                                        defaultValue={property.propertyAddress.pinno}
                                        name={`descriptionOfLand.properties[${index}].propertyAddress.pinno`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                            pattern: {
                                                value: Digit.Utils.getPattern('Pincode'),
                                                message: "Please enter valid Pincode",
                                            },
                                        }}
                                        maxLength={6}
                                    />
                                    {morethanOneProperty && <Box sx={{ display: 'flex', gap: '.5rem', justifyContent: 'flex-end' }}>
                                        <IconButton color="primary" aria-label="Add more" onClick={() => appendProp(propertyEntry)}>
                                            <ButtonWrapper
                                                variant="contained"
                                                size="medium"
                                                label="Add"
                                                color="primary"
                                                sx={{ backgroundColor: '#157CB3' }}
                                            />
                                        </IconButton>
                                        {properties.length > 0 && index > 0 && (
                                            <IconButton color="error" aria-label="Delete" onClick={() => removeProp(index)}>
                                                <ButtonWrapper
                                                    variant="contained"
                                                    size="medium"
                                                    label="Remove"
                                                    color="secondary"
                                                />
                                            </IconButton>
                                        )}
                                    </Box>}
                                </div>
                            </div>
                        </React.Fragment>
                    ))}
                </div>}
                {watchApprovedLayout && <div className="formContainer">
                    {properties?.map((property, index) => (
                        <React.Fragment>
                            <div className="formHeaderContainer">
                                <h2 className="formHeading">
                                    {index > 0 ? t("Additional Registration Information") : t("Registration Information")}                                    </h2>
                            </div>
                            <div className="formInputContainer">
                                <div className="columnWrapper">
                                    <InputWrapper
                                        label="Property Type"
                                        control={control}
                                        placeholder="Select Property Type"
                                        defaultValue={property.propertyType.name}
                                        name={`descriptionOfLand.properties[${index}].propertyType.name`}
                                        type="selectInput"
                                        mandatory
                                        data={propertyTypeListUP}
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        control={control}
                                        label="Sector No."
                                        defaultValue={property.sectorNo}
                                        name={`descriptionOfLand.properties[${index}].sectorNo`}
                                        type="textInput"
                                        placeholder={"Enter Sector No."}
                                        mandatory
                                        maxLength={30}
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        control={control}
                                        label="Property Number"
                                        defaultValue={property.propertyNo}
                                        name={`descriptionOfLand.properties[${index}].propertyNo`}
                                        type="textInput"
                                        placeholder={"Enter Property No."}
                                        maxLength={30}
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        label="Plot Area(As per Allotment Letter)"
                                        control={control}
                                        placeholder="Enter Plot Area"
                                        defaultValue={property.plotArea}
                                        name={`descriptionOfLand.properties[${index}].plotArea`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required",
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        control={control}
                                        label={t("LABEL_ADDRESS")}
                                        placeholder={t("LABEL_ENTER_ADDRESS")}
                                        defaultValue={property.propertyAddress.address}
                                        name={`descriptionOfLand.properties[${index}].propertyAddress.address`}
                                        type="textInput"
                                        mandatory
                                        multiLine
                                        maxLength={150}
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                            pattern: {
                                                value: Digit.Utils.getPattern('Address'),
                                                message: "Please enter valid Address",
                                            },
                                        }}
                                    />
                                </div>
                                <div className="columnWrapper">
                                    <InputWrapper
                                        label="Property land use (as in allotment letter)"
                                        control={control}
                                        placeholder="Enter Land use as per master plan"
                                        defaultValue={property.appliedLandUse.name}
                                        name={`descriptionOfLand.properties[${index}].appliedLandUse.name`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        label="Scheme Name"
                                        control={control}
                                        placeholder="Select Scheme Name"
                                        defaultValue={property.schemeName}
                                        name={`descriptionOfLand.properties[${index}].schemeName`}
                                        type="selectInput"
                                        mandatory
                                        data={schemeNameList}
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        control={control}
                                        label="Block"
                                        placeholder={"Enter Block"}
                                        defaultValue={property.block}
                                        name={`descriptionOfLand.properties[${index}].block`}
                                        type="textInput"
                                        mandatory
                                        maxLength={30}
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        control={control}
                                        data={updistricts}
                                        label={t("LABEL_CITY")}
                                        placeholder={t("LABEL_ENTER_CITY")}
                                        defaultValue={property.city}
                                        name={`descriptionOfLand.properties[${index}].city`}
                                        type="selectInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            }
                                        }}
                                    />
                                    <InputWrapper
                                        control={control}
                                        label={t("LABEL_STATE")}
                                        defaultValue={property.propertyAddress.state || t("LABEL_STATE_UP")}
                                        name={`descriptionOfLand.properties[${index}].propertyAddress.state`}
                                        type="textInput"
                                        disabled
                                    />
                                    <InputWrapper
                                        control={control}
                                        label={t("LABEL_PINCODE")}
                                        placeholder={t("LABEL_ENTER_PINCODE")}
                                        defaultValue={property.propertyAddress.pinno}
                                        name={`descriptionOfLand.properties[${index}].propertyAddress.pinno`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                            pattern: {
                                                value: Digit.Utils.getPattern('Pincode'),
                                                message: "Please enter valid Pincode",
                                            },
                                        }}
                                        maxLength={6}
                                    />
                                    {morethanOneProperty && <Box sx={{ display: 'flex', gap: '.5rem', justifyContent: 'flex-end' }}>
                                        <IconButton color="primary" aria-label="Add more" onClick={() => appendProp(propertyEntry)}>
                                            <ButtonWrapper
                                                variant="contained"
                                                size="medium"
                                                label="Add"
                                                color="primary"
                                                sx={{ backgroundColor: '#157CB3' }}
                                            />
                                        </IconButton>
                                        {properties.length > 0 && index > 0 && (
                                            <IconButton color="error" aria-label="Delete" onClick={() => removeProp(index)}>
                                                <ButtonWrapper
                                                    variant="contained"
                                                    size="medium"
                                                    label="Remove"
                                                    color="secondary"
                                                />
                                            </IconButton>
                                        )}
                                    </Box>}
                                </div>
                            </div>
                        </React.Fragment>
                    ))}
                </div>}
                <div className="footerContainer">
                    <div className="buttonWrapper">
                        <ButtonWrapper
                            variant="contained"
                            color="error"
                            size="medium"
                            label="Prev"
                            sx={{ backgroundColor: '#CCC' }}
                            onClick={() => handleSubTabChange(2)}
                        />
                        <ButtonWrapper
                            variant="contained"
                            color="success"
                            size="medium"
                            label="Save"
                            type="submit"
                            sx={{ backgroundColor: '#157CB3' }}
                        />
                    </div>
                </div>
            </form>

        </section>
    );
};

export default SubStep4;
